import React from 'react';
import { useTranslation } from 'next-i18next';

const Prices = ({ show, prices, className = '' }) => {
    var _a, _b;
    const { t } = useTranslation('', { keyPrefix: '' });
    if (!show)
        return null;
    const parsePrice = (price) => {
        const match = price.match(/(\d[\d\s,.]*)/);
        return match ? parseFloat(match[1].replace(/[^\d,]/g, '').replace(',', '.')) : null;
    };
    const oldPriceFirstRange = (_a = prices.oldPrice) === null || _a === void 0 ? void 0 : _a.split(' - ')[0];
    const newPriceFirstRange = (_b = prices.newPrice) === null || _b === void 0 ? void 0 : _b.split(' - ')[0];
    const oldPriceFirstNumber = parsePrice(oldPriceFirstRange);
    const newPriceFirstNumber = parsePrice(newPriceFirstRange);
    const shouldDisplayOldPrice = prices.oldPrice &&
        prices.oldPrice !== prices.newPrice &&
        ((prices.oldPrice.includes(' - ') && prices.newPrice.includes(' - ')) ||
            (!prices.oldPrice.includes(' - ') && !prices.newPrice.includes(' - '))) &&
        oldPriceFirstNumber !== newPriceFirstNumber;
    return (React.createElement("div", { className: `product-prices ${className}` },
        shouldDisplayOldPrice && (React.createElement(React.Fragment, null,
            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.originalPrice')),
            React.createElement("p", { className: "product-price old strike" }, prices.oldPrice),
            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.price')))),
        prices.newPrice && React.createElement("p", { className: "product-price" }, prices.newPrice)));
};

export { Prices as P };
//# sourceMappingURL=Prices-J1SqTpik.js.map
